<!--
All rights reserved © 2012, 2020 BuserNet Consulting LLC
 -->
<template>
  <IonPage>
    <SentinelElement />
    <RouteHeader
      id="btn-route-selector-grid"
      :settings="settings"
      :is-marked-favorite="isMarkedFavorite"
      @showTour="showtour"
      @openRouteSelectModal="openRouteSelectModal"
    />
    <ion-content
      v-if="isActiveRoute"
      class="hasfooter"
      force-overscroll="false"
    >
      <AppLoader />
      <div
        v-show="noDataFound"
        id="routeprofileNoDataMessage"
        class="no-data no-data-display"
      >
        <font-awesome-icon icon="exclamation-circle" />
        <span>{{ noDataFoundRouteMessage }}</span>
      </div>
      <grid-view-chart
        ref="chartApi"
        :settings="settings"
      />
      <etd-slider
        id="bn-etd-slider-gridview"
        ref="etdSliderApi"
        :no-pin="true"
        :class="{
          unpinned: hideBottomAxis,
          pinned: !hideBottomAxis
        }"
        :style="{
          opacity:
            departTime != 'ETD:  NaN  NaN:NaN' &&
            departTime != 'ETD:  NaN  NaNNaNZ' &&
            (showSlider || settings.sliderPinned)
              ? '1'
              : '0',
          'pointer-events': showSlider || settings.sliderPinned ? 'all' : 'none'
        }"
        @pinToggled="togglePin"
        @changing="sliderChanging"
      />
      <div
        v-if="enableAlternateSlider || hideBottomAxis"
        id="floating-etd-button"
        :style="floatingEtdStyle"
        class="floating-etd"
      >
        <FooterSliderLabelButton
          :label="departTime"
          :show-icon="false"
        />
      </div>
    </ion-content>
    <ion-footer v-show="!hideBottomAxis && !enableAlternateSlider">
      <ion-toolbar color="dark">
        <UTCClock />
        <ion-title>
          <FooterSliderLabelButton
            id="footer-slider-label-button-grid"
            :label="departTime"
          />
        </ion-title>
        <layer-update-time-trigger-button
          :layer-for="getViewKeyName"
        />
      </ion-toolbar>
    </ion-footer>
    <v-tour
      name="viewTour"
      :steps="toursteps"
      :callbacks="tourCallbacks"
    />
  </IonPage>
</template>
<script>
import {
  IonContent,
  IonFooter,
  IonPage,
  IonTitle,
  IonToolbar,
} from '@ionic/vue';
import _debounce from 'lodash/debounce';
import ChartConst from '../../constants/chart.constant';
import AppConst from '../../constants/app.constant';
import EventConst from '../../constants/event.constant';
import bnd3Service from '../../services/bnd3.service';
import routeControllerService from '../../services/routeController.service';
import searchHistoryService from '../../services/searchHistory.service';
import gridViewService from './Gridview.service';
import reportService from '../../services/report.service';
import utilityService from '../../services/utility.service';
import etdService from '../../services/etd.service';
import ConfigApplicationSettings from '../../config/application.config';
import ConfigDeviceSettings from '../../config/device.config';
import routeProfileService from '../Routeprofile/Routeprofile.service';
import FavoritesService from '../../components/Favorites/Favorites.service';
import GridViewChart from '../../components/GridViewChart/GridViewChart.vue';
import EtdSlider from '../../components/EtdSlider.vue';
import RouteHeader from '../../components/RouteHeader.vue';
import UTCClock from '../../components/UTCClock.vue';
import FooterSliderLabelButton from '../../components/FooterSliderLabelButton.vue';
import Emitter from '../../bus';
import { showAeroplane, hideAeroplane } from '../../services/aeroplane.service';
import HelpBoxConfig from '../../components/HelpBox/HelpBox.config';
import LayerUpdateTimeTriggerButton from '../../components/layerUpdateTime/layerUpdateTimeTriggerButton.vue';
import { ViewKeysMap } from '../../constants/layerUpdateTime.constant';

export default {
  name: 'Gridview',
  components: {
    IonContent,
    IonFooter,
    IonPage,
    IonTitle,
    IonToolbar,
    GridViewChart,
    EtdSlider,
    RouteHeader,
    UTCClock,
    FooterSliderLabelButton,
    LayerUpdateTimeTriggerButton,
  },
  data() {
    return {
      settings: {},
      showAdvanced: false,
      dateFormat: null,
      sliderMainObj: null,
      departTime: null,
      routeProfileData: null,
      showSlider: true,
      allDataForInterval: [],
      currentSliderIndex: null,
      isMarkedFavorite: false,
      noDataFound: false,
      noDataFoundRouteMessage: ChartConst.noDataFoundRouteMessage,
      toursteps: HelpBoxConfig['app.gridview'].steps,
      floatingEtdStyle: {
        visibility: 'hidden',
        top: 0,
      },
      enableAlternateSlider:
        ConfigDeviceSettings.settings.enableAlternateSlider,
      hideBottomAxis: utilityService.hideBottomAxis(),
    };
  },
  computed: {
    isActiveRoute() {
      return this.$router.currentRoute.value.name === 'app.gridview';
    },
    getViewKeyName() {
      return ViewKeysMap.GRIDVIEW;
    },
  },
  methods: {
    refreshView() {
      const vm = this;
      vm.hideBottomAxis = utilityService.hideBottomAxis();
      if (vm.settings) {
        vm.initRouteProfile();
        if (vm.settings.sliderPinnedOldState) {
          vm.settings.sliderPinned = vm.settings.sliderPinnedOldState;
        } else if (vm.settings.sliderPinnedOldState === false) {
          vm.settings.sliderPinned = vm.settings.sliderPinnedOldState;
        }
        if (vm.hideBottomAxis) {
          vm.settings.sliderPinned = true;
        }
      }
      vm.setTourSteps();
    },
    handleResizeEvent: _debounce(function () {
      this.refreshView();
    }, ChartConst.resizeDebounce),
    ionViewDidEnter() {
      const vm = this;
      // This timeout makes sure that these is smooth transition of view

      vm.initializeView();
      Emitter.on(
        EventConst.refreshViewRootscope + AppConst.stateMap.gridview.key,
        vm.initializeView,
      );
      reportService.bindReportMethod(AppConst.dataMode.gridview);
      utilityService.changeTourElementPosition();
      vm.setTourSteps();
      Emitter.on(
        EventConst.favorite.listRefreshed,
        vm.isMarkedFavoriteCheckForStar,
      );
      vm.$nextTick(() => {
        window.addEventListener('resize', this.handleResizeEvent);
      });
    },
    ionViewWillLeave() {
      const vm = this;
      utilityService.stopTour();
      Emitter.off(EventConst.tapped_outside);
      Emitter.off(
        EventConst.favorite.listRefreshed,
        vm.isMarkedFavoriteCheckForStar,
      );
      Emitter.off(
        EventConst.refreshViewRootscope + AppConst.stateMap.gridview.key,
      );
      Emitter.off(EventConst.tourEvent);
      reportService.unbindReportMethod();
      window.removeEventListener('resize', this.handleResizeEvent);
    },
    showtour() {
      const vm = this;
      if (!vm.noDataFound) {
        vm.$tours.viewTour.start();
      }
    },
    setDateFormat() {
      routeControllerService.setDateFormatRoute(this);
    },
    syncRouteData() {
      routeControllerService.syncRouteData(this.settings);
    },
    loadViewVairables() {
      routeControllerService.loadViewVairables(this);
    },
    loadRouteprofileSetting() {
      routeControllerService.loadRouteprofileSetting(this);
    },
    cleanUpSpace() {
      routeControllerService.cleanUpSpace(this);
    },
    togglePin(state) {
      routeControllerService.togglePin(state, this);
    },
    loadSliderDatesDependency(data) {
      routeControllerService.loadSliderDatesDependency(data, this);
    },
    loadSliderDataAndProfileData(data) {
      routeControllerService.loadSliderDataAndProfileData(data, this);
    },
    getAllIntervalData() {
      routeControllerService.getAllIntervalDataRoute(this);
      gridViewService.buildGridViewMap(
        this.settings,
        this.sliderMainObj,
        ConfigApplicationSettings.settings,
        this.routeProfileData,
      );
    },
    openRouteSelectModal() {
      routeControllerService.openRouteSelectModal(this);
    },
    refreshChart(travelRoute, fullData, softDraw) {
      const vm = this;
      etdService.setDepartureTime(vm.settings.departureTime);
      fullData.gridDataObject = gridViewService.getGridViewData(
        travelRoute,
        fullData,
        vm.settings.departureTime,
      );
      fullData.travelRoute = travelRoute;
      if (vm.$refs.chartApi && vm.$refs.chartApi.refresh) {
        vm.$refs.chartApi.refresh(fullData, vm.settings, softDraw);
      }
    },
    loadRouteProfileData(data, isSoftDraw) {
      const vm = this;
      vm.routeProfileData = data;
      vm.refreshChart(
        vm.routeProfileData.travelRoute,
        vm.routeProfileData,
        isSoftDraw,
      );
    },
    markItemAsFav(item) {
      FavoritesService.markItemAsFav(item);
    },
    initRouteProfile() {
      const vm = this;
      showAeroplane();
      utilityService.clearAuditFactory();
      gridViewService.cleanMap();
      vm.isMarkedFavorite = FavoritesService.isMarkedFavorite(vm.settings);
      vm.noDataFound = false;
      routeProfileService
        .getRouteProfileData(
          vm.settings,
          AppConst.dataMode.gridview,
          routeControllerService,
          vm.openRouteSelectModal,
        )
        .then((data) => {
          if (data && data.isValidRoute !== false) {
            vm.loadSliderDataAndProfileData(data);
            searchHistoryService.loadAirportHistorySearch();
          } else {
            vm.departTime = ChartConst.departurePrefix
              + vm.dateFormat(vm.settings.departureTime);
            vm.sliderMainObj = [];
          }
          if (data === null) {
            vm.noDataFound = true;
          }
          hideAeroplane();
        });
    },
    updateTravelRouteLive() {
      const vm = this;
      vm.refreshChart(
        routeProfileService.getTravelRoute(
          vm.settings.departureTime,
          vm.settings,
        ),
        vm.routeProfileData,
        true,
      );
    },
    updateTravelRoute() {
      const vm = this;
      vm.refreshChart(
        routeProfileService.getTravelRoute(
          vm.settings.departureTime,
          vm.settings,
        ),
        vm.routeProfileData,
      );
      etdService.saveDepartureTimeToLs();
    },
    sliderChanging(sliderEventData) {
      const vm = this;
      vm.departTime = sliderEventData.departTimeDisplay;
      vm.settings.departureTime = sliderEventData.departTime;
      bnd3Service.hideD3ToolTip();
      if (!sliderEventData.isInitializing) {
        routeControllerService.shiftEtdSliderLabel(vm, sliderEventData);
        if (sliderEventData.isDragEnd) {
          vm.updateTravelRoute();
          routeControllerService.hideFloatingSlider(vm);
        } else {
          vm.updateTravelRouteLive();
        }
      }
    },
    initializeView() {
      routeControllerService.initializeView(this);
    },
    isMarkedFavoriteCheckForStar() {
      FavoritesService.isMarkedFavoriteCheckForStar(this, this.settings);
    },
    setTourSteps() {
      utilityService.setTourSteps(this, 'app.gridview');
    },
  },
};
</script>
